export class AnnotationUtil {
    /**
     * Create a canvas element with dimensions and offset of the reference element
     * @param {HTMLElement} element
     * @param {boolean} append
     * @param {boolean} insert
     * @returns {HTMLCanvasElement}
     */
    static createCanvasForElement(element, devicePixelRatio, append = true, insert = false) {
        const canvas = document.createElement('canvas');
        const rect = element.getBoundingClientRect();
        let canvasTop = '0';
        let canvasLeft = '0';
        if (insert) {
            canvasLeft = `${element.offsetLeft}px`;
            canvasTop = `${element.offsetTop}px`;
        }
        canvas.style.position = 'absolute';
        canvas.style.top = canvasTop;
        canvas.style.left = canvasLeft;
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;
        canvas.width = rect.width * devicePixelRatio;
        canvas.height = rect.height * devicePixelRatio;
        if (insert && append) {
            element.appendChild(canvas);
        }
        else if (insert) {
            element.parentNode.insertBefore(canvas, element.nextSibling);
        }
        return canvas;
    }
}
//# sourceMappingURL=AnnotationUtil.js.map